<template>
  <div class="job-detail-info-page">
    <!-- 头部按钮 -->
    <!-- <div class="handle-box">
      <div class="left">
        <div class="leapin-tags leapin-blue">Be an early applicant</div>
        <div class="leapin-tags leapin-blue">Less than 25 applicants</div>
      </div>
      <div class="right">
        
        <div class="leapin-light-huge-button ob-small">
          <img :src="dislike" />
        </div>
        <div class="leapin-light-huge-button ob-small">ASK  LEAPIN</div>
        
      </div>
    </div> -->
    <!-- 次级按钮 -->
    <div class="company-title">
      <div class="over-view">Overview</div>
      <div class="share-but">
        <div 
          :class="[
            'leapin-light-huge-button',
            'ob-small',
            nowMarkType == 1 ? 'marked' : ''
          ]"
          @click="markPosition(detailData.id,nowMarkType)">
          <img :src="star" />
        </div>
        <div class="leapin-primary-huge-button ob-small" @click="openOriginUrl(detailData.id, detailData.origin_url)">
          <img :src="linkAirWhite" /> APPLY 
        </div>
        <!-- <div class="leapin-light-huge-button ob-small">
          <img :src="linkAir" /> Share
        </div>
        <div class="leapin-light-huge-button ob-small">
          <img :src="linkAir" /> Report
        </div>
        <div class="leapin-light-huge-button ob-small">
          <img :src="linkAir" /> Original Job Post
        </div> -->
      </div>
    </div>
    <!-- 公司信息 -->
    <div class="company-info">
    <div class="image">
      <img v-if="detailData.company_logo_url != null && detailData.company_logo_url" class="logo" :src="detailData.company_logo_url" />
      <div v-else class="logo leapin-logo-avatar">{{ detailData.company_name[0] }}</div>
      <!-- <span class="stress">Host Hotels & Resorts</span> · 2 hours ago -->
    </div>
    <div class="name">
      {{ detailData.name }}
    </div>
     <!-- 职位要求 -->
     <div class="company-icons">
      <el-row :gutter="100">
        <el-col :span="7"><div class="ci-item"><img :src="comLocation" /> {{ getEmptyBack(detailData.location) }}</div></el-col>
        <el-col :span="5"><div class="ci-item"><img :src="comJobtype" />{{ jobTypeList.find(item => item.value == detailData.office_type).name }}</div></el-col>
        <el-col :span="6"><div class="ci-item"><img :src="comWorktype" />{{ detailData.office_type < 3 ? officeTypeList.find(item => item.value == detailData.office_type).name : '-' }}</div></el-col>
      </el-row>
      <!-- <el-row :gutter="100">
        <el-col :span="8"><div class="ci-item"><img :src="comSalary" />{{ getEmptyBack(detailData.salary) }}</div></el-col>
        <el-col :span="6" class="leapin-ellipsis"><div class="ci-item"><img :src="comLevel" />{{ '-' }}</div></el-col>
        <el-col :span="8"><div class="ci-item"><img :src="comExp" />{{ getEmptyBack(detailData.experience) }} years exp</div></el-col>
      </el-row> -->
    </div>
    </div>
    <!-- 增加面试机会、寻找coach -->
    <div class="find-more-changes">
      <div class="find-buttons">
        <div>Maximize your interview chances</div>
        <div class="leapin-felx-center-12">
          <div class="leapin-light-huge-button ob-small" @click="$router.push('/CoachList')">
            <img :src="linkAir" /> Ask coach to help
          </div>
          <!-- <div class="leapin-light-huge-button ob-small">
            <img :src="linkAir" /> Generate Custom Resume
          </div> -->
        </div>
      </div>
      <div class="content">
        {{ detailData.company_desc == null ? '---' : detailData.company_desc }}
      </div>
      <!-- <div class="leapin-felx-start-12 leapin-w-100 leapin-mb-20">
        <div class="leapin-tags leapin-blue">Finance</div>
        <div class="leapin-tags leapin-blue">Real Estate</div>
        <div class="leapin-tags leapin-blue"><img :src="rightCircle" /> Comp.& Benefits</div>
      </div> -->
    </div>
    <!-- 关于coach -->
    <div class="about-coach">
      <!-- <div class="item-title"><img :src="linkAir" />  Responsibilities</div>
      <el-row class="ac-content">
        <el-col :span="24">
          {{ detailData.description==null ? '---' : detailData.description }}
        </el-col>
      </el-row> -->
      <div class="leapin-felx-between">
        <div class="item-title"><img :src="linkAir" /> Qualification</div>
        <div class="skill-have"><img :src="rightCircle" /> Skills you have</div>
      </div>
      <div class="ac-content">
        Find out how your skills align with this job's requirements.
      </div>
      <div class="leapin-felx-start-12 leapin-w-100 leapin-mb-20">
        <div 
          :class="[
            'leapin-tags',
            e.isMatch ? 'leapin-blue' : 'leapin-gary',
          ]" 
          v-for="(e,i) in skillsList"
          :key=i>
          <img v-if="e.isMatch" :src="rightCircle" /> {{ e.name }}
        </div>
        <!-- <div class="leapin-tags leapin-gary">Lead Generation</div> -->
      </div>
      <div class="item-title"><img :src="linkAir" />  Required</div>
      <el-row class="ac-content">
        <el-col :span="24">
          <pre>
{{ detailData.description=='' ? '---' : detailData.description }}
          </pre>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { jobsMark } from '@/services/jobs'
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  name: 'jobDetailInfo',
  data() {
    return {
      nowMarkType: 0,
      skillsList: [], // 技能列表
      jobTypeList: [
        { value: 0, name: 'Full-time' },
        { value: 1, name: 'Part-time' },
        { value: 2, name: 'Internship' },
        { value: 3, name: 'Contract' },
        { value: 4, name: 'Temporary' },
        { value: 5, name: 'Other' },
      ],
      companyStageList: [
        { value: 0, name: 'Early Stage' },
        { value: 1, name: 'Growth Stage' },
        { value: 2, name: 'Late Stage' },
        { value: 3, name: 'Pubilc Company' },
      ],
      officeTypeList: [
        { value: 0, name: 'Onsite' },
        { value: 1, name: 'Remote' },
        { value: 2, name: 'Hybrid' },
      ],
      logo: require('@/assets/images/jobs/company2.png'),
      dislike: require('@/assets/svgs/dislike.svg'),
      star: require('@/assets/svgs/star.svg'),
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      linkAir: require('@/assets/svgs/link-air.svg'),
      rightCircle: require('@/assets/svgs/right-circle.svg'),
      comLocation: require('@/assets/svgs/location-company.svg'),
      comJobtype: require('@/assets/svgs/jobtype-company.svg'),
      comExp: require('@/assets/svgs/exp-company.svg'),
      comSalary: require('@/assets/svgs/salary-company.svg'),
      comWorktype: require('@/assets/svgs/worktype-company.svg'),
      comLevel: require('@/assets/svgs/level-company.svg'),
    }
  },
  watch: {
    detailData: {
      handler(val) {
        // 有匹配的标签
        if (val.qualification_trait) {
          this.skillsList = []
          let target = val.qualification_trait.recruitment_skills
          let arr = []
          for (let i in val.qualification_trait.skills_match) {
            arr.push(i)
          }
          target.forEach(item => {
            let obj = {
              name: item,
              isMatch: arr.includes(item)
            }
            this.skillsList.push(obj)
          });
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.nowMarkType = this.detailData.mark_type
  },
  methods: {
    // 标记职位
    markPosition(id,type) {
      let parmas = {
        job_id: id,
        mark_type: type == 1 ? 4 : 1, // 0-recommend 1-like 2-applied 3-collected 4-unlike
      }
      this.nowMarkType = parmas.mark_type
      jobsMark(parmas).then(res => {
        if (res.code === 0) {
          this.$message.success(res.message)
          this.$emit("refreshJobList")
        }
      })
    },
    openOriginUrl(id, url) {
      this.markPosition(id, 2)
      window.open(url)
    },
  }
}
</script>
<style scoped lang="scss">
.job-detail-info-page {
  background: #fff;
  border-radius: 30px 30px 0 0;
  padding: 20px 32px 64px;
  font-family: "PingFang SC";
  .item-title {
    color: #000;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    letter-spacing: 0.5px;
    img {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
  }
  .ob-small {
    height: 24px !important;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .handle-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    .left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 0 12px;
    }
    .right {
      display: flex;
      gap: 0 10px;
    }
  }
  .company-title {
    padding: 12px 0;
    border-bottom: 1px solid #E6E8F0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .over-view {
      border-radius: 100px;
      background: #6E62E5;
      color: #FFF;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 12px;
    }
    .marked {
      background: #e9e8fa !important
    } 
    .share-but {
      display: flex;
      gap: 0 12px;
      justify-content: center;
      align-items: center;
    }
  }
  .company-info {
    display: flex;
    gap: 12px 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 12px 0;
    .logo {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
    }
    .image {
      color: #000;
      font-size: 13px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 14px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .stress {
        font-weight: 600;
      }
    }
    .name {
      color: #000;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
    .company-icons {
      width: 100%;
      padding: 12px 0 32px;
      border-bottom: 1px solid #E6E8F0;
      display: flex;
      flex-direction: column;
      gap: 16px 0;
      .ci-item {
        display: flex;
        gap: 0 8px;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  .find-more-changes {
    padding: 20px 0;
    border-bottom: 1px solid #E6E8F0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 20px 0;
    .find-buttons {
      width: 100%;
      padding: 12px;
      color: #FFF;
      font-size: 13px;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 100px;
      background: linear-gradient(90deg, #46C8FF 0%, #6E62E5 100%);
    }
    .content {
      width: 100%;
      color: #000;
      font-size: 13px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .about-coach {
    padding: 20px 0;
    .ac-content {
      color: #666;
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      margin-bottom: 20px;
    }
    .skill-have {
      color: #666;
      font-size: 13px;
      font-weight: 400;
    }
  }

}
</style>
